import i18next from 'i18next';
import React from 'react';
import en from './i18n/en';
import ptBr from './i18n/pt-br';

i18next.addResourceBundle('pt-br', 'financeiro/conta', ptBr);
i18next.addResourceBundle('en', 'financeiro/conta', en);

const ContaConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  routes: [
    {
      path: '/financeiro/cadastro/conta',
      component: React.lazy(() => import('./Conta')),
    },
  ],
};

export default ContaConfig;
